import { render, staticRenderFns } from "./committeeFooter.vue?vue&type=template&id=0e411ab9&scoped=true"
import script from "./committeeFooter.vue?vue&type=script&lang=js"
export * from "./committeeFooter.vue?vue&type=script&lang=js"
import style0 from "./committeeFooter.vue?vue&type=style&index=0&id=0e411ab9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_7d97cc52897b1b5edd1ee8818c6a75fc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e411ab9",
  null
  
)

export default component.exports